var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"root__sub-headline heading",attrs:{"sub-brand":_vm.subBrand}},[_c('span',{staticClass:"heading__text"},[_vm._t("default")],2),_c('Tooltip',{staticClass:"heading__info"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }